<template>
    <div class="main-cont-cal-tab" id="style-3">
        <div class="con-sal">
            <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
            <a href="#" class="btn btn-outline-info btn-sm" v-print="'#list'">Print List</a>
            <a href="#" class="btn btn-outline-warning btn-sm" v-print="'#segnaposto'">Print segnaposto</a>
        </div>
        <div class="cont-data-pi">
             <v-date-picker v-model="date" mode="dateTime"  />
        </div>
        <div class="cont-tab">
            <table class="table" id="list">
                <thead class="thead-dark">
                    <tr>
                        <th class="text">Nome</th>
                        <th class="text">Cognome</th>
                        <th class="text">Coperti</th>
                        <th class="text">Orario</th>
                        <th class="text">Sala</th>
                        <th class="text">Tavolo</th>
                        <th class="text">Seleziona per Stampa segnaposto</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="prenot in prenotazionisala" :key="prenot.tm">
                            <td class="text pointer" >{{prenot.nome}}</td>
                            <td class="text" >{{prenot.cognome}}</td>
                            <td class="text" >{{prenot.coperti}}</td>
                            <td class="bg" >{{moment.unix(prenot.tm).format('h:mm A')}}</td>
                            <td class="bg" >{{prenot.codicesala}}</td>
                            <td class="bg" >{{prenot.numero}}</td>
                            <td><input type="checkbox"  @click="(e)=>getSegnaPosto(prenot.cognome,prenot.coperti,prenot.numero,e)"></td>
                        </tr>
                    </tbody>
            </table>
        </div>
        <div  id="segnaposto" >
            <div class="segnaposto"  v-for="listItem in listToPrint" :key="listItem.cognome">
                <div class="card">
                    <div class="card-header print" >
                        RISERVATO 
                    </div>
                    <div class="card-body">
                        <h5 class="card-title print">SIGN {{listItem.cognome}}</h5>
                        <p class="card-text print">Per {{listItem.coperti}}</p>
                        <p href="#" class="print" >Tavolo {{listItem.tavolo}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>



<script>
import moment from 'moment'
import { store } from '../store/store.js'
export default {
  name: 'StampaPrenotati',
  data: function () {
            return {
                date: new Date(),
                prenotazionisala:[],
                printList:[],
                listToPrint:[],
                store
            }
   },
   methods: {
        home() {
        this.$router.push({ name: "Gestionale"})
    },
    getSegnaPosto (cognome,coperti,tavolo,e) {
       if(e.target.checked) {
           this.listToPrint.push({cognome,coperti,tavolo})
       }else {
           const index = this.listToPrint.findIndex(prenotazione => prenotazione.cognome == cognome);
           this.listToPrint.splice(index,1)
       }
        
    },
    displayPrenotazioni() {
        var prenotazioni =[];
        this.moment = moment;
        var end = moment(this.date).endOf('day').unix();
        var start = moment(this.date).startOf('day').unix();
        //var data = moment(this.date).unix();
        console.log('la richiesta è inviata')
        this.axios.post(this.store.path+'displayPrenotazioni',{end:end,start:start,codicesala:this.sala,stato:'prenotato',tutte:true,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            if(response.data){
                console.log(response.data);
                response.data.messaggio.forEach(function(el){
                    console.log(el);
                    prenotazioni.push(el);
                })
                this.prenotazionisala = prenotazioni;
            }else{console.log('Non è Stato Possibile prenotare il Tavolo')}
        })

    },

   },
   computed : {
      aggiornaOrdine(){
          let data = this.date;
            return data;
        },
   },
   watch:{
      aggiornaOrdine:{
          deep:true,
          handler:function(val){
              if(val){
                  console.log(val);
                  this.displayPrenotazioni();
                  
                } 
            }
        },
   },
   beforeMount() {
      this.displayPrenotazioni();
  },
}
</script>




<style scoped>
.main-cont-cal-tab {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: auto;
}
 @media print
   {
        .print{
            text-align: center !important;
        }
        .segnaposto {
            margin-bottom: 10px;
        }
    }
#style-3::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
  background-color: #000000;
}


</style>